import styled, { css } from "styled-components";
import { colors } from "../../consts";
import { IconButtonStyled } from "../Buttons/styled";
import WrapperContainer from "../Containers/WrapperContainer";

export const PagesWrapper = styled.div`
  display: flex;
  width: 100%;
  border-bottom: 1px solid ${colors.RAISIN_10};
  margin-top: 24px;
  height: 48px;

  .page-item-list {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;

    height: 52px;
    overflow-y: auto;
  }
`;

const PageItemErrorStyles = css`
  color: ${colors.ERROR};
`;

export const PageItem = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  color: ${colors.RAISIN_80};
  padding: 0 16px;
  position: relative;
  min-width: 48px;
  height: 46px;

  transition: 0s !important;
  transition: opacity 0.5s !important;

  ${(props) =>
    props.isActive &&
    `font-weight: 700;
    color: ${colors.RAISIN_100};
  `}

  ${(props) => props?.hasError && PageItemErrorStyles}

  &:disabled {
    cursor: default;
    pointer-events: none;
    color: ${colors.RAISIN_50};
  }

  &::after {
    content: ${(props) => (props.isActive ? "''" : "unset")};
    width: 100%;
    height: 2px;
    background-color: ${(props) => (props?.hasError ? colors.ERROR : colors.RAISIN_100)};
    position: absolute;
    bottom: -2px;
    left: 0;
  }
`;

export const AddButtonContainer = styled(WrapperContainer)`
  ${IconButtonStyled} {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    width: 48px;
    height: 48px;

    svg {
      path {
        fill: ${colors.RAISIN_50};
      }
    }

    &:hover {
      opacity: 1;
      background: ${colors.RAISIN_20};
    }
  }
`;
